import { useEffect, useState } from "react";
import api from "@/lib/api";
import { Calendar, MapPin } from "lucide-react";

function fmtDate(iso) { try { return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "long", year: "numeric" }); } catch { return ""; } }

export default function Agenda() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/agenda").then((r) => setItems(r.data)); }, []);
  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
      <div className="mb-10">
        <div className="text-xs uppercase tracking-widest text-[#0086C6] font-semibold mb-2">Kalender</div>
        <h1 className="font-heading font-bold text-3xl lg:text-5xl text-[#003A5C]">Agenda Kegiatan</h1>
      </div>
      <div className="space-y-4">
        {items.map((a) => (
          <div key={a.id} className="lift-card flex items-start gap-5 p-5 bg-white rounded-2xl border border-slate-100">
            <div className="w-16 h-16 rounded-xl bg-[#003A5C] text-white grid place-items-center shrink-0">
              <div className="text-center">
                <div className="text-[10px] uppercase tracking-widest text-[#48CAE4]">{new Date(a.tanggal_mulai).toLocaleDateString("id-ID", { month: "short" })}</div>
                <div className="font-heading font-bold text-2xl leading-none mt-0.5">{new Date(a.tanggal_mulai).getDate()}</div>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="font-heading font-bold text-[#003A5C] text-lg">{a.judul}</h3>
              <div className="flex flex-wrap gap-4 mt-2 text-sm text-slate-600">
                <div className="inline-flex items-center gap-2"><Calendar className="w-4 h-4 text-[#00B4D8]" /> {fmtDate(a.tanggal_mulai)}{a.tanggal_selesai && a.tanggal_selesai !== a.tanggal_mulai ? ` — ${fmtDate(a.tanggal_selesai)}` : ""}</div>
                <div className="inline-flex items-center gap-2"><MapPin className="w-4 h-4 text-[#00B4D8]" /> {a.lokasi}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
